export default __webpack_public_path__ + "static/media/ca_4.8e3e7f17.png";